<template>
  <div class="home">
    <skeletonIndex v-if="skeletonLoading" />
    <div v-else>
    <div class="top-box">
      <img class="banner-bg" src="../assets/banner_bg.png" alt="" />
      <div class="top-content">
        <div id="new-home-search-form">
<!--          <van-search-->
<!--            v-model="searchInput"-->
<!--            shape="round"-->
<!--            background="#fdd80d"-->
<!--            placeholder="精品专区一元秒杀中，比拼多多最低还要低，千万别错过"-->
<!--          />-->
          <div class="search-box left-justifying" @click="goSearch">
            <img src="../assets/search_icon.png" alt="">
            <div class="animate-txt-box">
              <div class="animate-txt">【全球灯云】值得骄傲的城市！      <span style="display: inline-block;margin: 0 17.33333vw;">送中国人有面子的【全球灯云】</span>        精品生活、精品人生！</div>
            </div>
          </div>
        </div>
        <div class="banner-box">
          <div class="banner-img-box">
            <van-swipe style="height: 50.4vw;" :autoplay="5000" class="my-swipe" :show-indicators="false">
              <van-swipe-item v-for="(image, index) in bannerList" :key="index" @click="goGoodDes(image.url)">
                <img v-lazy="image.image" class="banner-img-item" :src="image.image" />
              </van-swipe-item>
            </van-swipe>
          </div>
          <img class="decorate-img" src="../assets/decorate_img.png" alt="" />
        </div>
      </div>
    </div>
    <!--  导航菜单-->
    <div id="new-home-nav">
      <div class="new-home-nav-box">
        <div class="nav-item" v-for="(item,index) in navList" :key="index" @click="goNextPage(item)">
          <div class="nav-item-sec">
<!--            <router-link to='/goodClassify'>-->
              <img :src="item.icon" alt="" />
              <div class="item-name">{{item.name}}</div>
<!--            </router-link>-->
          </div>
        </div>
      </div>
    </div>
    <!--  菜单end-->
    <!-- 横幅广告 -->
<!--    <div class="ad-block-1">-->
<!--      <div>-->
<!--&lt;!&ndash;        <router-link  :to="{path:'/login'}" >&ndash;&gt;-->
<!--          <img v-for="(item,index) in adOneList" @click="goPage(item.url)" :key="index" :src="item.image" alt="" />-->
<!--&lt;!&ndash;        </router-link>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
    <!-- 横幅广告end -->
    <!--    1元秒杀-->
      <div id="ad-block-2" class="ad-block-2">
        <div class="justify-align">
          <div>
            <div class="title-box" style="display: inline-block;margin-right: 2vw;">
              <div class="title-txt">一元秒杀</div>
              <div class="title-box-line"></div>
            </div>
            <div style="display: inline-block" v-if="show_status == 1">
              <div class="down-time" v-if="msTxtShow==false"><span>{{showTime.H}}</span>：<span>{{showTime.M}}</span> ：<span>{{showTime.S}}</span></div>
              <div  class="down-time" style="color: #F23926;font-weight: bold;" v-else>秒杀中</div>
            </div>
          </div>
          <div class="left-justifying f-title-right" v-if="show_status ==1">
            <img src="../assets/z_icon.png" alt="" /><div> <span>{{full_time}}</span> 开抢</div>
          </div>
        </div>
        <div class="yuan-box-box">
          <div class="yuan-item-sec" v-for="(item,index) in oneList" :key="index">
            <div class="item-yuan" v-for="(good,i) in item.onepay_goods" :key="i" @click="goDesGood(good.goods_id,good.id,good.useful_stock)">
              <van-image :src="good.goods.image" alt="" lazy-load />
              <div class="price-box">
                <div class="price-df" :style="{color: (index == 0 ?'#F23926':'#999')}">￥{{good.price}}</div>
<!--                <div class="price-original">￥{{good.goods.market_price}}</div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    <!--    1元秒杀end-->
<!--      手信souvenir -->
      <div id="ad-block-6" class="ad-block-2">
        <div class="justify-align">
          <div class="title-box" style="display: inline-block;margin-right: 2vw;">
            <div class="title-txt">手信区</div>
            <div class="title-box-line"></div>
          </div>
          <div @click="goSouvenirList" class="right-box" style="color: #A1A0A0;font-size: 3.2vw;">
             更多>
          </div>
        </div>
        <div class="yuan-box" id="gift-goods">
            <div class="item-yuan" v-for="(good,i) in giftGoods" :key="i" @click="goDesGoodGift(good.id)">
              <img :src="good.image" alt="" />
              <div class="price-box">
                <div class="price-df">￥{{good.price}}</div>
                <div class="price-original">￥{{good.market_price}}</div>
              </div>
            </div>
        </div>
      </div>
      <!--      手信end-->
<!--      商品列表-->
<!--      <div class="">-->
<!--        <div class="justify-align" style="margin-right: 2.66667vw;">-->
<!--          <div class="title-box" style="display: inline-block;margin-right: 2vw;">-->
<!--            <div class="title-txt">新增类目</div>-->
<!--            <div class="title-box-line"></div>-->
<!--          </div>-->
<!--          <div @click="goSouvenirList" class="right-box" style="color: #A1A0A0;font-size: 3.2vw;">-->
<!--            更多>-->
<!--          </div>-->
<!--        </div>-->
<!--        <indexGoodsItem :goodsItemList="giftGoods" />-->
<!--      </div>-->
<!--      商品类别end-->
    <!--  老马探厂-->
    <div id="ad-block-3">
      <div class="justify-align">
        <div class="title-box">
          <div class="title-txt">精彩预告</div>
          <div class="title-box-line"></div>
        </div>
<!--        <div class="right-box">-->
<!--          查看全部 >-->
<!--        </div>-->
      </div>
      <div class="foreshow-list-box">
        <template v-for="(items,index) in factoryList">
          <div class="one-box justify-align" :key="index" v-if="items.number==1">
<!--            <a :href="item.url" v-for="(item,i) in items.items" :key="i">-->
<!--              <img :src="item.image" alt="" />-->
<!--            </a>-->
<!--            <swiper class="swiper" :options="swiperOptionOne">-->
<!--              <swiper-slide class="factory-item-a" v-for="(item,i) in items.items" :key="i">-->
<!--                <a :href="item.url">-->
<!--                  <img :src="item.image" alt="" />-->
<!--                </a>-->
<!--              </swiper-slide>-->
<!--            </swiper>-->
            <van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
              <van-swipe-item class="factory-item-a" v-for="(item,i) in items.items" :key="i">
                <a :href="item.url">
                  <img :src="item.image" alt="" />
                </a>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="two-box justify-align" :key="index" v-if="items.number==2">
            <swiper class="swiper" :options="swiperOptionTwo">
              <swiper-slide class="factory-item-a" v-for="(item,i) in items.items" :key="i">
                <a :href="item.url">
                  <img :src="item.image" alt="" />
                </a>
              </swiper-slide>
            </swiper>
          </div>
          <div class="three-box justify-align " :key="index" v-if="items.number==3">
            <swiper class="swiper" :options="swiperOptionThree">
              <swiper-slide class="factory-item-a" v-for="(item,i) in items.items" :key="i">
                <a :href="item.url">
                  <img :src="item.image" alt="" />
                </a>
              </swiper-slide>
            </swiper>
          </div>
          <div class="four-box justify-align " :key="index" v-if="items.number==4">
            <swiper class="swiper" :options="swiperOptionFour">
              <swiper-slide class="factory-item-a" v-for="(item,i) in items.items" :key="i">
                <a :href="item.url">
                  <img :src="item.image" alt="" />
                </a>
              </swiper-slide>
            </swiper>
          </div>
        </template>
      </div>

      <!--      <div class="list-factory-box">-->
<!--        <a :href="item.url" class="factory-item" v-for="(item,index) in factoryList" :key="index">-->
<!--          <div class="factory-info left-justifying">-->
<!--            <van-image class="factory-info-img" round :src="item.img" alt="" lazy-load />-->
<!--            <div class="factory-info-txt">-->
<!--              <div class="name">{{item.name}}</div>-->
<!--              <div class="des-text">{{item.des}}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="info-course-box left-justifying" style="align-items: self-start;">-->
<!--            <van-image :src="item.img" alt="" class="course-img" lazy-load />-->
<!--            <div class="course-info">-->
<!--              <div class="title-box-course">{{item.title}}-->
<!--              </div>-->
<!--              <div class="tag-box left-justifying">-->
<!--                <div class="tag-item">带货主播</div> <div class="tag-item">抖音</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </a>-->
<!--      </div>-->

    </div>
    <!--  老马探厂end-->
    <div class="ad-block-1">
      <div>
<!--        <router-link  :to="{path:'/login'}" >-->
        <van-image v-for="(item,index) in adCourse" :key="index" :src="item.image" lazy-load alt="" />
<!--        </router-link>-->
      </div>
    </div>
    <!-- 横幅广告end -->
<!--    课程-->
    <div class="course-modules">
        <div class="title-box">
          <div class="title-txt">【互联网营销师】精品课程</div>
          <div class="title-box-line"></div>
        </div>
       <div class="course-modules-list">
           <a :href="item.url" v-for="(item,index) in courseList" class="info-course-box course-modules-item left-justifying" :key="index" style="align-items: self-start;">
             <van-image :src="item.cover" alt="" class="course-img" lazy-load />
             <div class="course-info">
               <div class="title-box-course">{{item.title}}
               </div>
               <div class="tag-box left-justifying">
                 <div class="tag-item" v-for="(tag,index) in item.keywords" :key="index">{{tag}}</div>
               </div>
             </div>
           </a>
       </div>
<!--      <a v-for="(item,index) in courseList" :href="item.url" :key="index">{{item.name}}</a>-->
    </div>
<!--    课程-->
      <a v-for="(item,index) in homeCourseMore.ad_content" :href="item.url" :key="index">
        <div class="kc-more-box">
          <img class="kc-more" :src="item.image" alt="" />
        </div>
      </a>

    </div>
    <div class="null-box"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import { Lazyload } from 'vant' // 导入懒加载模块Lazyload
Vue.use(Lazyload) // 注册懒加载指令
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import Swiper2, {Navigation, Pagination, Autoplay} from 'swiper';
import store from "../store";
Swiper2.use([Navigation, Pagination, Autoplay]);
import skeletonIndex from "@/components/skeleton/skeletonIndex";
// import indexGoodsItem from "@/components/indexGoodsItem";
export default {
  name: 'Home',
  components: {
    Swiper,
    SwiperSlide,
    skeletonIndex,
    // indexGoodsItem
  },
  data () {
    return {
      skeletonLoading:true, // 骨架屏
      swiperOptionOne: {
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        loop:false,
        speed: 3000,
        autoplay: 3000
      },
      swiperOptionTwo: {
        slidesPerView: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 5,
        loop:false,
        speed: 3000,
        autoplay: 3000
      },
      swiperOptionFour: {
        observer: true,
        observeParents: true,
        slidesPerView: 4,
        spaceBetween: 5,
        loop:false,
        speed: 3000,
        autoplay: 3000
      },
      swiperOptionThree: {
        observer: true,
        observeParents: true,
        slidesPerView: 3,
        spaceBetween: 5,
        loop:false,
        speed: 3000,
        autoplay: 3000
      },
      courseList: [],
      time: 1 * 60 * 60 * 1000,
      timeData: {
        hours: 5,minutes:56,seconds:15
      },
      searchInput: '',
      page: 1,
      finished: false,
      goodsList: [],
      login: 1, // // 0显示登陆 1隐藏
      bannerList: [],
      adList: [],
      factoryList: [],
      oneList: [],
      navList:[],
      adCourse: [],
      adOneList: [],
      oneGoods: '',
      giftGoods:[], // 手信
      endTime:'2021-10-15 15:58',
      finishedTime: '', // 活动结束时间
      showTime: {
        H: 0,
        M: 0,
        S: 0
      }, //倒计时
      msTxtShow: false, // false:显示倒计时  true：显示秒杀中
      msIsShow: false, // 判断秒杀是否显示
      colorMs: false, // 当天有秒杀 颜色为红色 别的为灰色
      full_time: '', // 开抢时间
      tips_time: '', // 提示购买文案
      homeCourseMore: '',
      show_status: 1,// 1显示 0隐藏倒计时
      scrollTop: '',
      indexDataArr: [], //首页全部数据
    }
  },

  updated() {
    // window.scroll(0, 0);
  },
  beforeCreate() {		//在页面创建之前设置body的背景色
    document.querySelector('body').setAttribute('style', 'background: #f5f5f5;')
  },
  beforeRouteLeave(to, from, next) { // 记录当前离开位置，为了返回后回到之前位置
    let position = window.scrollY //记录离开页面的位置
    console.log('离开位置',position)
    if (position == null) position = 0
    this.$store.commit('changeRecruitScrollY', position) //离开路由时把位置存起来
    next()
  },
  beforeRouteEnter(to, from, next) { // to: 即将要进入的目标  from: 当前导航正要离开的路由
    // console.log('to',to)
    // console.log('from',from)
    next(vm => {
      // 回到原来的位置
      if (from.name == 'GoodDetails' || from.name == 'goodClassify' || from.name == 'activityTheme'){
        let recruitScrollY = vm.$store.state.recruitScrollY
        window.scroll(0, recruitScrollY)
        console.log('回到原来的位置',recruitScrollY)
      } else {
        console.log('零零')
        window.scroll(0, 0)
      }

    })

  },
  created () {
    // this.getlist()
    // console.log('token',this.$store.state.token)
    // console.log('tabbarFalg',this.$store.state.tabbarFalg)
    var that = this
    var token = that.$store.state.token
    // var token = 'Bearer 1|lQMa9L71V0A86jD3xcqBNI6yrvIEx2dTAkccpfdT'
    if (token == ''){
      that.$store.commit('setTabbarShow',false);
      // this.wxCode = this.getQueryString('code')
      // var code = this.getQueryString('code')
      // console.log('zheli sss')
      // if (code !='' && code !=null && this.login==1) {
      //   // that.getLogin()
      //   console.log('这里有code 请求接口')
      //   that.getLogin()
      // } else { // code 为空
      //   that.$store.commit('setTabbarShow',false);
      //   console.log('code 为空 要获取code 要登录登录')
      //   console.log(this.$store.state.tabbarFalg)
      //   if(token==''){
      //     that.login=0; // 显示登录
      //     that.$store.commit('setTabbarShow',false);
      //     this.toGetWXCode() // 获取code
      //   } else {
      //     that.login=1; // 隐藏登录
      //     that.$store.commit('setTabbarShow',true);
      //   }
      // }
    } else {
      // console.log('you token ')
      that.login= 1; // 隐藏登录
      that.$store.commit('setTabbarShow',true);
      // that.getIndexData()
      // that.getOnePayData()
    }
    that.getIndexData()
    that.getOnePayData()
    this.getGoodListGift() // 手信
    // 清掉下单信息，防止存储过多
    this.$store.commit("setGoodsInfo",'');
    this.$store.commit("setSubmitNumber",'')
    this.$store.commit("setPayTypeId",'')// 一元购
    this.$store.commit("setPayInfo",'');
    this.$store.commit("setCartIds",'');
  },
  mounted() {
    // window.addEventListener("beforeunload", this.fn);
    // this.ignoreLoopLimit()
  },
  methods: {
    fn(){
      window.scrollTo(0,0);
    },
    ignoreLoopLimit() {
      const e = window.onerror
      window.onerror = function(err) {
        if (err === 'ResizeObserver loop limit exceeded') {
          console.warn('Ignored: ResizeObserver loop limit exceeded')
          return false
        } else {
          return e(...arguments)
        }
      }
    },
    goGoodDes(url){
      // console.log(url)
      window.open(url)
      // this.$router.push({path: url})
    },
    async getGoodListGift () { // 手信
      var data ={
        gift_goods: 1,
        number: 12
      }
      const res = await this.$Http.getGoodsList(data)
      if (res.code == 200){
        // console.log('res',res.data.data)
        this.giftGoods = res.data.data

      } else if(res.code == 401){ // token 过期
        this.$toast(res.message)
        store.commit("setToken", ''); // 清除key
        store.commit('setUserInfo', '')
        this.$router.go(0)
      } else {
        this.$toast(res.message)
      }
    },
    goSouvenirList(){
      // this.$router.push({path: '/souvenirList'})
      // this.$router.push({path: '/souvenirList'})
      var type= 'gift'
      this.$router.push({name:'activityTheme',params: {type:type}});
    },
    goPage(url){
      this.$router.push({path: url})
    },
    goNextPage(item){
      console.log(item)
      var url = item.uri
      let urlPage = url.split('https')
      // console.log(urlPage)
      if (urlPage.length==2){
        // console.log(item.uri)
        window.open(item.uri)
        // window.open('https://kuailong.itos.cn/Wechat/Index/index.html?state=0dfc590eedcfb742c6ef1ac247259760cb886062')
      } else {
        // console.log(1111)
        this.$router.push({path: url})
      }
    },
    clickDes(url){
      var url = url
      // console.log(url)
      // window.open(url)
      window.location.href(url)
    },
    goSearch(){
      this.$router.push('/searchList');
    },
    goDesGoodGift(id){
      this.$router.push({path:'/goodDetails',query:{id:id}})
    },
    goDesGood(gid,tid,isPay){
      // tid 一元购商品项目id  onepay_goods[].id
      var useful_stock = isPay // 是否秒杀有库存
      if (this.msTxtShow ==true && useful_stock != 0){ // 一元秒杀中
        this.$router.push({path:'/goodDetails',query:{id:gid,type:tid,isPay:isPay}})
      } else {
        this.$router.push({path:'/goodDetails',query:{id:gid}})
      }
    },
    async getOnePayData() { // 获取一元购
      var data = {
        is_home: 1
      }
      const res = await this.$Http.getOnePay(data)
      if (res.code==200){
        var arr = res.data
        this.oneList = arr
        var oneItem = arr[0]
        this.full_time =arr[0].tips_time
        // var endTime = oneItem.date+ ' ' + oneItem.hour+':00'
        var endTime = oneItem.full_time
        // console.log(endTime)
        this.endTime = endTime  // 秒杀时间
        this.finishedTime =this.getTime(1)+ ' '+ '00:00' // 秒杀时间<=现在<次日0点：秒杀中   得到 后1 天的时间
        let msTime = oneItem.date // 秒杀时间
        let nowTime = this.getTime(0)
        // console.log('秒杀时间',oneItem.date)
        this.show_status = arr[0].show_status
        console.log('staus',this.show_status)
        // if (msTime == nowTime && oneItem.onepay_goods[0].useful_stock != 0){ // 才会显示秒杀
        //       console.log('秒杀')
        //     this.showTimes() // 显示倒计时
        //     this.msIsShow = true // 显示倒计时
        //
        //     if (oneItem.onepay_goods[0].useful_stock != 0){
        //       this.colorMs = true
        //     } else {
        //       this.colorMs = false
        //     }
        // } else {
        //   this.msIsShow = false //
        //   this.showTimes() // 显示倒计时
        //   // console.log('今天没有秒杀')
        //
        // }
        //  判断是否在秒杀中解决后退
        let nowTimeCurr = new Date().getTime(); // 当前时间
        let startDate = arr[0].full_time; // 四点钟倒计时
        startDate = startDate.replace(new RegExp('-', 'gm'), '/');
        let startDateM = new Date(startDate).getTime(); //得到毫秒数
        // console.log('startDate',startDate)
        let lefttime = startDateM - nowTimeCurr;
        if (lefttime > 0) { // 倒计时中
          this.msTxtShow = false //  false:显示倒计时  true：显示秒杀中
        }else {
          this.msTxtShow = true
        }
        //  判断是否在秒杀中解决后退end
        if (this.show_status == 1){
          this.showTimes()
        }

      } else {

        this.$toast(res.message)
      }
      // console.log(res)
    },
    getTime(val) { //   获取时间并格式化
      // 获取前val天的时间
      var dt = new Date;
      val === 0 ? '' : dt.setTime(dt.getTime() + 24 * 60 * 60 * 1000 * val)
      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");
      return `${y}-${m}-${d}`;  // 获取的时间格式为 2021-04-09 09:34:00
      // return `${y}-${m}-${d} `;  // 获取的时间格式为 2021-04-09
      // return y+m+d+hh+mm+ss  // 获取的时间格式为 20210409093733
      // return y + m + d  // 获取的时间格式为  20210409
    },
    showTimes(val) {
      let that = this;
      let interval = setInterval(() => {
        let nowTime = new Date().getTime(); // 当前时间
        let startDate = that.endTime; // 四点钟倒计时
        startDate = startDate.replace(new RegExp('-', 'gm'), '/');
        let startDateM = new Date(startDate).getTime(); //得到毫秒数
        // console.log('startDate',startDate)
        let lefttime = startDateM - nowTime;
        if (lefttime > 0) { // 倒计时中
          that.showTime.H = Math.floor(lefttime / (1000 * 60 * 60)) < 10 ? '0' + Math.floor(lefttime / (1000 * 60 * 60)) : Math.floor(lefttime / (1000 * 60 * 60)); //计算小时数
          that.showTime.M = Math.floor((lefttime / (1000 * 60)) % 60) < 10 ? '0' + Math.floor((lefttime / (1000 * 60)) % 60) : Math.floor((lefttime / (1000 * 60)) % 60); //计算分钟数
          that.showTime.S = Math.floor((lefttime / 1000) % 60) < 10 ? '0' + Math.floor((lefttime / 1000) % 60) : Math.floor((lefttime / 1000) % 60); //计算秒数
          this.msTxtShow = false //  false:显示倒计时  true：显示秒杀中
        } else { // 秒杀时间<=现在<次日0点：秒杀中
          // console.log('秒杀中')
          let nowTime = new Date().getTime(); // 当前时间
          let finishedTime = this.getTime(1)+ ' '+ '00:00' // 秒杀时间<=现在<次日0点：秒杀中   得到后1 天的时间
          // console.log('当前finishedTime',finishedTime)
          let finishedTimeDate = finishedTime.replace(new RegExp('-', 'gm'), '/');
          let finishedTimeM = new Date(finishedTimeDate).getTime(); //得到毫秒数 第二天时间
          // console.log('finishedTimeM',finishedTimeM)
          // console.log('当前Time',finishedTimeM)
          // console.log('秒杀时间',startDateM)
          // if (startDateM <= nowTime || nowTime < finishedTimeM){ //  秒杀时间<=现在<次日0点：秒杀中
          //   // startDateM：秒杀时间 nowTime：当前时间  finishedTimeM：判断秒杀时间结束
          //   this.msTxtShow = true //  false:显示倒计时  true：显示秒杀中
          //   // var msTxt = '秒杀中'
          //   // console.log('秒杀中')
          // } else { // 倒计时
          //   this.msTxtShow = false; // 秒杀文字隐藏
          //
          // }
          this.msTxtShow = true
          // this.msTxtShow = true //  false:显示倒计时  true：显示秒杀中
          that.showTime.H = '00';
          that.showTime.M = '00';
          that.showTime.S = '00';
          clearInterval(interval);
        }
      }, 1000);
    },
    async getIndexData () {
      // var data = {
      //   page: this.page
      // }
      const res = await this.$Http.getHomeData()
      if (res.code==200){
          this.bannerList = res.data.banner
          this.navList = res.data.icon
          this.adCourse = res.data.adv.homeLower.ad_content
          this.adOneList= res.data.adv.homeUpper.ad_content
          this.factoryList = res.data.preview
          this.courseList = res.data.course
          this.homeCourseMore = res.data.adv.homeCourseMore
        // console.log('preview',this.factoryList)
        this.$store.commit('setAddressInfo',''); // 清除掉缓存的地址
        this.$store.commit('setGoodsInfo',''); // 清除掉缓存的商品
        this.skeletonLoading = false
        // this.$toast(res.message)
       document.addEventListener('scroll',this.handelscroll) // 获取位置
      } else {
        this.$toast(res.message)
      }
     // console.log(res)
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);  //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null)
        context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined" ? "" : context;
    },
    toGetWXCode() {
      var that = this
      let redirectUrl = encodeURIComponent('http://jpzs-zst.itos.cn/')
      let WX_APPID = 'wxe86e357621c76520'
      let oAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WX_APPID}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      var code = this.getQueryString('code')
      console.log('code3',code)
      if (code != '' || code != null) {
        that.login = 0;
        // console.log('login5', this.login)
        window.location.href = oAuthUrl
        this.login = 0;

      }
    },
    async getLogin(){ // 授权登录 Login
      var that  = this;
      var data = {
        code: this.wxCode,
        source: 'ZHQQ'
      }
      var res = await that.$Http.login(data)
      if (res.code == 200){
        this.$store.commit("setToken", res.data.token); // 保存token
        // localStorage.setItem('token',res.data.token)
        that.$store.commit('setTabbarShow',true);
        console.log('登录成功')
        that.login= 1; // 隐藏登录
        that.getIndexData()
      } else{
        console.log('要登录')
        this.$toast(res.message)
        that.login=0
        that.$store.commit('setTabbarShow',false);
        this.$store.commit("setToken", ''); // 清除key
      }

    },
  }
}
</script>
<style lang="scss" scoped>
.kc-more-box{
  width: 696px;margin: 10px auto 0;
  .kc-more{
    width: 100%;display: block;height: auto;
  }
}

.home{
  margin-bottom: 130px;
}
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #ee0a24;
}
.block {
  display: inline-block;
  width: 38px;
  color: #fff;
  font-size: 24px;
  text-align: center;
  background: #F23926;
  border-radius: 8px;
}
.one-box{
 border-radius: 12px;max-height:400px;
  overflow: hidden;margin-bottom: 12px;
}
.one-box img{
  max-height:400px;width: 100%;
}
.weixin-icon{width: 140px;height: 140px; margin: 100px auto 60px;display: block;}
.save-btn{width: 90%;height: 88px;line-height: 88px;text-align: center;font-size: 30px;color: #fff;
  background: #03d10e; margin: 100px auto 0;
  border-radius: 65px;}
.top-box {
  position: relative;
  .banner-bg{
    width: 100%;height: auto;display: block;
  }
  .top-content{
    position: absolute;
    width: 100%;left: 0;top: 0;
    #new-home-search-form{
      width: 696px;
      height: 60px;line-height: 60px;
      background: rgba(255, 255, 255, 0.63);
      border-radius: 30px; margin: 29px auto 24px;font-size: 24px;color: #8C8C8C;font-weight: 400;overflow: hidden;
      img{
        width: 34px;height: auto;margin-left: 20px;display: inline-block;
      }
      .animate-txt-box{
        width: 610px;margin-left: 10px;
        overflow: hidden;display: inline-block;
      }
      .animate-txt{
        height: 60px;line-height: 60px;
        display: inline-block;
        white-space: nowrap;
        animation: 20s wordsLoop linear infinite normal;
      }
    }
    .banner-box{
      //width: 750px;overflow: hidden;
      width: 696px;margin: 24px auto 0;overflow: hidden;
      .decorate-img{
        width: 100%;height: auto;display: block;margin-top: -80px;position: relative;z-index: 1;
      }
      .banner-img-box{
        border-radius:8px;
        overflow: hidden;
        .my-swipe{
          height: 378px;
        }
        .banner-img-item{
          width: 100%;display: block;
          height: 378px;
        }
      }

    }
  }
}
@keyframes wordsLoop {
  0% {
    transform: translateX(200px);
    -webkit-transform: translateX(200px);
  }
  100% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
}

@-webkit-keyframes wordsLoop {
  0% {
    transform: translateX(200px);
    -webkit-transform: translateX(200px);
  }
  100% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
}
.van-search__content{
  background-color: #f7f8faba;
}
#new-home-nav {
  margin-top: 230px;
  .new-home-nav-box{
    flex-wrap: wrap;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 10px;
    .nav-item{
      width: 20%;font-size: 26px;
      .nav-item-sec{
        margin: 20px;text-align: center;
        img{
          width: 100%;height: auto;display: block;margin-bottom: 10px;
        }
        .item-name{color: #333333;}
      }
    }
  }
}
.ad-block-1 {
  width: 694px;
  margin: 50px auto 23px;
  img{
    width: 100%;height: auto;display: block;margin-top: 20px;
  }
}
.f-title-right{
  font-weight: bold;
  color: #282828;font-size: 22px;
  span{
    color: #F23926;
  }
  img{
    margin-right: 10px;height: auto;display: block;width: 22px;
  }
}
.ad-block-2 {
  width: 664px;
  padding: 0 15px;
  margin: 0 auto 23px;text-align: left;background: #ffffff;border-radius: 12px;
  .down-time{
    display: inline-block;
    span{
      background: #F23926;color: #ffffff;
      border-radius: 8px;display: inline-block;padding: 2px 10px;font-size: 24px;
    }
  }
  .title-box{
    display: inline-block;font-size: 32px;color: #1D1D1D;font-weight: bold;margin-left: 24px;
    position: relative;padding: 22px 0;
    .title-txt{
       width: 143px;text-align: center;
    }
    .title-box-line{
      width: 143px;
      height: 15px;
      background: #FEDC32;
      border-radius: 8px;margin-top: -15px;
    }
  }

}
.title-box{
  display: inline-block;font-size: 32px;color: #1D1D1D;font-weight: bold;margin-left: 24px;
  position: relative;padding: 22px 0;
  .title-txt{
    width: 143px;text-align: center;
  }
  .title-box-line{
    width: 143px;
    height: 15px;
    background: #FEDC32;
    border-radius: 8px;margin-top: -15px;
  }
}
.yuan-box-box{
  flex-wrap: wrap;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: nowrap;
  margin-top: 10px;
  width: 100%;
 overflow-y: auto;
  .yuan-item-sec{
    display: inline-block; flex-wrap: nowrap;display: flex;
  }
  .item-yuan{
    font-size: 24px;color: #AEAEAE;display: inline-block;margin-right: 20px; width: 115px;
    img{
      width: 124px;
      height: 124px;display: block;margin: 0 auto;
    }
    .price-box{
      text-align: center;padding-bottom: 20px;padding-top: 20px;
    }
    .price-df{
      font-weight: bold;
      color: #F23926;
      line-height: 28px;font-size: 30px;
    }
    .price-original{
      text-decoration:line-through;
    }
  }
}
#gift-goods{
  display: flex;
  flex-wrap: nowrap;
  margin-top: 10px;
  width: 100%;
  overflow: hidden;overflow-x: auto;
  .item-yuan{
    font-size: 24px;color: #AEAEAE;display: inline-block;margin-right: 20px; width: 150px;
    img{
      width: 150px;
      height: 124px;display: block;margin: 0 auto;
    }
    .price-box{
      text-align: center;padding-bottom: 20px;padding-top: 20px;
    }
    .price-df{
      font-weight: bold;
      color: #F23926;
      line-height: 28px;font-size: 30px;
    }
    .price-original{
      text-decoration:line-through;
    }
  }
}
.yuan-box{
  //flex-wrap: wrap;
  //display: -webkit-box;
  //display: -ms-flexbox;
  display: flex;
  flex-wrap: nowrap;
  margin-top: 10px;
  width: 100%;
  overflow: hidden;
  .yuan-item-sec{
    display: inline-block; flex-wrap: nowrap;display: flex;
  }
  .item-yuan{
    font-size: 24px;color: #AEAEAE;display: inline-block;margin-right: 20px; width: 146px;
    img{
      width: 124px;
      height: 124px;display: block;margin: 0 auto;
    }
    .price-box{
      text-align: center;padding-bottom: 20px;padding-top: 20px;
    }
    .price-df{
      font-weight: bold;
      color: #F23926;
      line-height: 28px;font-size: 30px;
    }
    .price-original{
      text-decoration:line-through;
    }
  }
}
.foreshow-list-box{
  .factory-item{
    img{
      width: 100%;height: 200px;border-radius: 12px;
    }

  }
  .two-box{
    overflow: hidden;margin-bottom: 12px;
    .factory-item-a{
      width: 49%;display: block;
      img{
        width: 100%;height: 200px;border-radius: 12px;
      }
    }
  }
  .three-box{
    overflow: hidden;margin-bottom: 12px;
    .factory-item-a{
      width:32%;display: block;
      img{
        width: 100%;height: 200px;border-radius: 12px;
      }
    }
  }
  .four-box{
    margin-bottom: 12px;
    .factory-item-a{
      width:24%;display: block;
      img{
        width: 100%;height: 200px;border-radius: 12px;
      }
    }
  }
}
#ad-block-3{
  width: 696px;margin: auto auto;
  .right-box{
    font-size: 28px;color: #B2B5B1;font-weight: bold;
  }
  .list-factory-box{
    .factory-item{display: block;
     padding: 24px;
      background: #FFFFFF;
      border-radius: 12px;margin-bottom: 22px;
      .factory-info{
        .factory-info-img{
          width: 100px;
          height: 100px;
          border-radius: 50%;background: #cccccc;
        }
        .factory-info-txt{
          text-align: left;font-weight: 400;
          color: #B6B6B6;
          font-size: 24px;margin-left: 20px;
          .name{
            font-weight: bold;
            color: #272727;font-size: 28px;margin-bottom: 10px;
          }
        }
      }
      .info-course-box{
        margin-top: 26px;position: relative;
        .course-img{
          width: 250px!important;
          height: 150px;
          background: #8C8C8C;
          border-radius: 10px;display: block;margin-right: 20px;
        }
        .course-info{
          .title-box-course{
            font-size: 24px;
            font-weight: 400;
            color: #1D1D1D;
            line-height: 36px;text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
          }
          .tag-box{
            position: absolute;
            bottom: 0;left: 260px;width: 390px;
            .tag-item{
              padding: 5px 10px;

              background: #FFF4BE;font-size: 18px;color: #EDA10E;
              border-radius: 5px;margin-left: 10px;
            }
          }
        }
      }
    }
  }

}
.course-modules{
  text-align: left;
  width: 696px;margin: auto auto;
.title-box{
  text-align: left;margin-left: 0;
  .title-txt{
    text-align: left;
    width: 480px;
  }
  .title-box-line{
    width: 410px;
  }
 }
  .course-modules-list{
    .course-modules-item{
      background: #ffffff;padding: 20px;
      position: relative;
      margin-bottom: 20px;
      .course-img{
        width: 250px;
        height: 150px;
        //background: #8C8C8C;
        border-radius: 10px;display: block;margin-right: 20px;
      }
      .course-info{
        width: 400px;
        .title-box-course{
          font-weight: 400;
          color: #1D1D1D;
          line-height: 36px;text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;font-size: 28px;
        }
        .tag-box{
          margin-top: 30px;position: absolute; left: 280px;bottom: 20px;width: 390px;
          .tag-item{
            padding: 5px 10px;

            background: #FFF4BE;font-size: 18px;color: #EDA10E;
            border-radius: 5px;margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
